import { useState, useEffect, useRef } from "react";
import Title from "../../Text/Title/Title";
import BigText from "../../Text/BigText/BigText";
import {
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
} from "reactstrap";
import { useNotification } from "../../../hooks/useNotification";
import { FillingBottle } from "react-cssfx-loading";
import { FaPen } from "react-icons/fa6";
import useApiRequests from "../../../hooks/useApiRequests.tsx";
import "./Task.css";
import {
  FaArrowAltCircleLeft,
  FaArrowAltCircleRight,
  FaExchangeAlt,
  FaRegEye,
} from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import { FaTrash } from "react-icons/fa6";
import { IMember } from "../../../interfaces/IMember.tsx";
import { IFilters } from "../../../interfaces/IFilters.tsx";

import { Tooltip } from "react-tooltip";
import Badge from "../../Badge/Badge.tsx";
import { BsArrowDownSquareFill, BsArrowUpSquareFill } from "react-icons/bs";
import { IStatus } from "../../../interfaces/IStatus.tsx";
import { Chip, Box, Grid } from "@mui/material";
import MoveTaskModal from '../../MoveTaskModal/MoveTaskModal.tsx'
import { IFrontTask } from "../../../interfaces/ITask.tsx";
import { ITool } from "../../../interfaces/ITool.tsx";
import { FaStar } from "react-icons/fa";


const periodOptions: string[] = [
  "Últimos 7 dias",
  "Mês atual",
  "Hoje",
  "Últimos 30 Dias",
  "Todo o Tempo",
  "Personalizado",
];

function TasksList() {
  const isFirstRender = useRef(true);

  const [pageScreening, setIsPageScreening] = useState(false);
  const [newComment, setNewComment] = useState("");
  const [isLoading, setIsLoading] = useState(true)

  const [boardTasks, setBoardTasks] = useState<IFrontTask[]>([]);
  const [currentMember, setCurrentMember] = useState<IMember>();
  const [modalAvoidTask, setModalAvoidTask] = useState(false);

  const [pagination, setPagination] = useState({
    data: boardTasks,
    page: 0,
    itemsPerPage: 30,
    totalPages: 0,
  });
  const [deleteModal, setDeleteModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState("");
  const [nextStateName, setNextStateName] = useState("");
  const [reproveStateName, setReproveStateName] = useState("");
  const [filters, setFilters] = useState<IFilters>();
  

  //Static Filters
  const [columnFilter, setColumnFilter] = useState({
    title: "",
    list: "-1",
    tool: "-1",
  });

  const [pageItens, setPageItens] = useState<IFrontTask[]>([]);
  const [filterBoxOpen, setFilterBoxOpen] = useState(false);
  const [tools, setTools] = useState<ITool[]>([]);
  const [avoidTaskId, setAvoidTaskId] = useState("");

  const navigate = useNavigate();
  const { notify } = useNotification();
  const { type } = useParams();

  const {
    getBoardTasks,
    getFilters,
    deleteTaskByTrelloId,
    moveTaskToList,
    moveTaskToNextStatus,
    getCurrentMember,
    avoidTask,
    getAllTools,
    isPageScreening,
  } = useApiRequests();



  const [modalMoveTask, setModalMoveTask] = useState(false);
  const [modalMoveTaskNextStatus, setModalMoveTaskNextStatus] = useState(false);
  const [statusToMoveManually, setStatusToMoveManually] = useState<any>({id:"", name:""})
  const [taskToMoveId, setTaskToMoveId] = useState('')


useEffect(()=> {
  if(statusToMoveManually.id !== '' && statusToMoveManually.name != ''){
    setModalMoveTask(!modalMoveTask)
  }
},[statusToMoveManually])

useEffect(()=> {
  if(taskToMoveId != ''){
    setModalMoveTaskNextStatus(!modalMoveTaskNextStatus)
  }
},[taskToMoveId])

const fetchFilters = async () => {
  try {
    const data = await getFilters();
    if (data.success) {
      data.data.selectedList = type || ""
      data.data.type = type || ""
      setFilters(data.data);
    }
  } catch (error) {
    notify(error, "error");
  }
};

  useEffect(() => {
    const fetchPageScreeening = async () => {
      const data = await isPageScreening(type || "");
      if (data.success) {
        setIsPageScreening(data.data);
      }
    };
    fetchPageScreeening();
    fetchFilters();
    fetchCurrentMember();
    const fetchTools = async () => {
      try {
        const data = await getAllTools();
        if (data.success) {
          setTools(data.data);
        }
      } catch (error) {
        notify(error, { type: "error" });
      }
    };
    setTimeout(() => {
      fetchTools();
      // handleFetchData();
    }, 1000);
  }, [type]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    handleFilterBy();
  }, [columnFilter]);

  useEffect(() => {
    let currentStateName: string = type ?? "";
    let reprvStateName =
      filters?.listData.find(
        (s) => s.name?.toLowerCase() == currentStateName?.toLowerCase()
      )?.reproveStateName ?? "";
    let nexttStateName =
      filters?.listData.find(
        (s) => s.name?.toLowerCase() == currentStateName?.toLowerCase()
      )?.nextStateName ?? "";
    handleFetchData();
    setReproveStateName(reprvStateName);
    setNextStateName(nexttStateName);
  }, [filters]);
  //#region handles
  // Cada nova busca de tarefas invalida as anteriores: se uma resposta antiga chegar depois
  // (ex.: trocar de filtro ou de rota rápido), ela é descartada em vez de sobrescrever a lista atual.
  const latestTasksRequest = useRef(0);

  const fetchBoardTasks = async (page: number) => {
    const requestId = ++latestTasksRequest.current;
    setIsLoading(true);
    try {
      const data = await getBoardTasks(pagination.itemsPerPage, page, filters);
      return requestId === latestTasksRequest.current ? data : null;
    } finally {
      if (requestId === latestTasksRequest.current) setIsLoading(false);
    }
  };

  const handleFetchData = async () => {
    if(!filters)return
    try {
      let newPage = 0;
      const data = await fetchBoardTasks(newPage);
      if (!data) return;
      if (data.success) {
        // Calculate the number of pages based on the itemsPerPage
        const totalPages = Math.ceil(
          data.data.totalItems / pagination.itemsPerPage
        );

        // Update pagination data
        setPagination((prevPagination) => ({
          ...prevPagination,
          data: data.data.items,
          totalPages,
          page:newPage
        }));

        setPageItens(sortByPartnerPriority(data.data.items));
      } else {
        notify(data.msg, { type: "error" });
      }
    } catch (error) {
      notify(error, { type: "error" });
    }
  };

  const fetchCurrentMember = async () => {
    try {
      let data = await getCurrentMember();
      if (data.success) {
        setCurrentMember(data.data);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleNewAvoidTask = async () => {
    const btn = document.getElementById("btn-avoid-task") as any;

    btn.disabled = true;
    btn.innerHTML = "...";

    try {
      if (newComment == "" || newComment.length == 0) {
        notify("O campo não pode estar vazio!", { type: "info" });
      } else {
        const data = await avoidTask(avoidTaskId, newComment);
        if (data.success) {
          setNewComment(data.data);
          setModalAvoidTask(false);
          setNewComment("");
          notify("Sucesso! A tarefa foi reprovada", {type: "success"});
          await handleFetchData();

        }
      }
    } catch (error) {
      notify(error, { type: "error" });
    } finally {
      btn.disabled = false;
      btn.innerHTML = "Confirmar";
    }
  };

  const canUserMoveTask = () => {
    return (
      currentMember?.memberType === "2" ||
      currentMember?.type === 2 ||
      currentMember?.canMoveTasksManually
    );
  };

  const  handlePageChange = async (newPage: number) => {

    setPagination((prevPagination) => ({
      ...prevPagination,
      page: newPage
    }));
    try {
      const response = await fetchBoardTasks(newPage);
      if (!response) return;

      if(response.success) {
        const totalPages = Math.ceil(
          response.data.totalItems / pagination.itemsPerPage
        );

        setPagination((prevPagination) => ({
          ...prevPagination,
          data: response.data.items,
          totalPages,
          page: newPage
        }));
        setPageItens(sortByPartnerPriority(response.data.items));
      } else {
        notify(response.msg, { type: "error" });
      }
    } catch (error) {
      notify(error, { type: "error" });
    }
  };

  const handleCustomDateChange = (field: any, value: any) => {
    setFilters((prevFilters: any) => ({
      ...prevFilters,
      customPeriod: {
        ...prevFilters.customPeriod,
        [field]: value,
      },
    }));
  };

  const handleGetData = async () => {
    const btn = document.getElementById("button-filter") as any;
    var initialPage = 0; // resetamos as páginas, para iniciar uma paginação com os novos filtros selecionados
    try {
      const data = await fetchBoardTasks(initialPage);
      if (!data) return;
      if (data.success) {
        // Calculate the number of pages based on the itemsPerPage
        const totalPages = Math.ceil(data.data.totalItems / pagination.itemsPerPage);
  
        setPagination((prevPagination) => ({
          ...prevPagination,
          data: data.data.items,
          totalPages,
          page: initialPage
        }));
        const sortedInitial = sortByPartnerPriority(data.data.items);
        setPageItens(sortedInitial);
        setBoardTasks(sortedInitial);
        // handleFilterBy();
      } else {
        notify(data.msg, "error");
      }
    } catch (error) {
      notify(error, { type: "error" });
    } finally {
      if (btn) {
        btn.disabled = false;
        btn.innerHTML = "Filtrar";
      }
    }
  };

  const handleEditItem = (id: string) => {
    localStorage.setItem("lastHref", window.location.href);
    navigate(`/task/edit/${id}`);
  };

  const handleViewTask = (id: string) => {
    localStorage.setItem("lastHref", window.location.href);
    pageItens.filter(x => x.trelloId == id)
    window.open(`/task/view/${id}`, "_blank");
  };

  const handleNewTask = () => {
    localStorage.setItem("lastHref", window.location.href);
    window.location.href = "/task/edit/new";
  };

  const handleDeleteItem = async () => {
    const btn = document.getElementById("btn-delete-task") as any;

    btn.disabled = true;
    btn.innerHTML = "...";
    const data = await deleteTaskByTrelloId(itemToDelete);
    if (data.success) {
      if (data.data) {
        handleFetchData();
        notify("Registro deletado com sucesso!", { type: "success" });
      }
    } else {
      notify("Ocorreu um erro ao deletar o registro!", { type: "error" });
    }

    setItemToDelete("");
    setDeleteModal(false);
    btn.disabled = false;
    btn.innerHTML = "Deletar";
  };

  const handleMoveTask = async (name: string, id: string) => {
    try {
      const data = await moveTaskToList(name, id);
      if (data.success) {
        if (data.data) {
          notify(`Tarefa movida com sucesso!`, { type: "success" });
          await handleFetchData();
        }
      } else {
        notify("Ocorreu um erro ao mover a tarefa: " + data.msg, {
          type: "error",
        });
      }
    } catch (error) {
      notify(error, { type: "error" });
    }
  };

  function padZero(number: number) {
    return number.toString().padStart(2, "0");
  }

  function objectIdToDate(objectId: any) {
    const timestamp = parseInt(objectId.substring(0, 8), 16) * 1000;

    const date = new Date(timestamp);

    const formattedDate = `${padZero(date.getDate())}/${padZero(
      date.getMonth() + 1
    )}/${date.getFullYear()}`;

    return formattedDate;
  }

  function countDays(objectId: any) {
    const timestamp = parseInt(objectId.substring(0, 8), 16) * 1000;
    const date = new Date(timestamp);
    const today = new Date();
    const diff = today.getTime() - date.getTime();
    return Math.floor(diff / (1000 * 60 * 60 * 24));
  }
  //#endregion handles

  function getPageTitle() {
    // Obter a parte da URL após "/tasks/"
    const route = window.location.pathname.replace("/tasks/", "");

    // Decodificar a parte da URL
    const decodedRoute = decodeURIComponent(route);

    // Capitalizar a primeira letra e substituir "+" por espaço
    const formattedRoute =
      decodedRoute.charAt(0).toUpperCase() +
      decodedRoute.slice(1).replace(/\+/g, " ");

    // Retornar o título formatado

    if (formattedRoute === "Mytasks") return "Minhas tarefas";
    if (formattedRoute === "All") return "Todas";

    return formattedRoute;
  }

  const getPriorityColor = (priority: string) => {
    switch (priority) {
      case "high":
      case "veryHigh":
        return "task-red";
      case "medium":
        return "task-orange";
      default:
        return "task-neutral";
    }
  };
  
  const isPartnerPriority = (t: IFrontTask) => (t.EhParceiroPrioritario ?? (t as any).ehParceiroPrioritario) === true;
  const sortByPartnerPriority = (items: IFrontTask[]) => {
    return [...items].sort((a, b) => {
      const ap = isPartnerPriority(a) ? 1 : 0;
      const bp = isPartnerPriority(b) ? 1 : 0;
      return bp - ap;
    });
  };

  const getItemPriority = (priority: string) => {
    switch (priority) {
      case "veryHigh":
        return "Altíssima";
      case "high":
        return "Alta";
      case "medium":
        return "Média";
    }

    return "Baixa";
  };

  const handleFilterBy = () => {
    if (boardTasks != null && boardTasks.length > 0) {
      let filteredTasks = boardTasks;
      const searchProperties = [
        "title",
        "partnerEmail",
        "customerEmail",
        "description",
        "listName",
        "devName",
        "toolsName",
        "priority",
        "version",
      ];
      if (columnFilter.title.toString() !== "") {
        const filteredData = boardTasks.filter((item) => {
          return searchProperties.some((prop) => {
            const value = (item as any)[prop];
            if (value) {
              if (Array.isArray(value)) {
                return value.some((element) =>
                  element
                    .toLowerCase()
                    .includes(columnFilter.title.toLowerCase())
                );
              } else if (typeof value === "string") {
                return value
                  .toLowerCase()
                  .includes(columnFilter.title.toLowerCase());
              }
            }

            return false;
          });
        });

        filteredTasks = filteredData as IFrontTask[];
      }

      if (columnFilter.list !== "-1" && columnFilter.tool != "") {
        filteredTasks = filteredTasks.filter((element) => {
          return element.listId === columnFilter.list;
        });
      }

      if (columnFilter.tool !== "-1" && columnFilter.tool != "") {
        filteredTasks = filteredTasks.filter((element) => {
          if (element.toolsName != null) {
            if (element.toolsName.includes(columnFilter.tool)) {
              return element;
            }
          }
        });
      }

      const totalPages = Math.ceil(
        filteredTasks.length / pagination.itemsPerPage
      );

      setPagination((prevPagination) => ({
        ...prevPagination,
        data: filteredTasks,
        totalPages,
      }));

      const startIndex = pagination.page * pagination.itemsPerPage;

      const endIndex = startIndex + pagination.itemsPerPage;

      const sorted = sortByPartnerPriority(filteredTasks || []);
      const slicedItens =
        sorted && sorted.slice(startIndex, endIndex);

      setPageItens(slicedItens);
    }
  };

  const handleAvoidTask = () => {
    setModalAvoidTask(true);
  };
  const handleMoveTaskNextStatus = async (name: string) => {
    try {
      var data = await moveTaskToNextStatus(name ? name : "");
      if (data.success) {
        notify("Tarefa movida com sucesso para o próximo status", {type: "success"});
        const newestData = await handleFetchData();
      } else {
        notify(data.msg, { type: "error" });
      }
    } catch (error) {}
  };

  function handleWithDate(dateString: string) {
    try {
      var date = new Date(dateString);

      var day = date.getUTCDate();
      var month = date.getUTCMonth() + 1;
      var year = date.getUTCFullYear();

      // Adicionar zero à esquerda se o dia ou mês for menor que 10
      var dayStr  = day < 10 ? "0" + day : day;
      var monthStr = month < 10 ? "0" + month : month;

      return dayStr + "/" + monthStr + "/" + year;
    } catch (error) {
      return ""; // Retorna uma string vazia em caso de erro
    }
  }
  const handleGoBack = () => {
    const lastHref = localStorage.getItem("lastHref");

    if(lastHref)
      window.location.href = lastHref;
  };

  return (
    <div className="page-container">
      <Tooltip id="move-dropdown" />
      <Tooltip id="edit-dropdown" />
      <Tooltip id="delete-dropdown" />
      <Tooltip id="view-dropdown" />
      <div className="d-flex align-center justify-content-between w-100">
        <div className="title-and-subtitle">
          <Title>{getPageTitle()}</Title>
        </div>

        <div className="d-flex gap-2">
          <Button
                color="secondary"
                style={{ height: "44px" }}
                onClick={() => handleGoBack()}
              >
                Voltar
              </Button>
        {
          pageScreening && 
          <Button
          color="success"
          style={{ height: "44px" }}
          onClick={() => handleNewTask()}
        >
          Nova Tarefa
        </Button>
        }
        </div>
      </div>
      <div className="mt-2 filters-container">
        <Row className="filters">
          <div className="filter-top-row">
            <div className="d-flex gap-4 w-100">
              <Col md={3} style={{ width: "339px" }}>
                <Input
                  className="custom-input"
                  id="task-title"
                  name="task-title"
                  placeholder="Palavras chaves"
                  type="text"
                  onChange={(event) =>
                    setFilters((prevFilters) => ({
                      ...prevFilters!,
                      keyWord: event.target.value,
                    }))
                  }
                  // value={filters.tasktitle}
                />
              </Col>
              {(type == "mytasks" || type == "all") && (
                <Col md={3} style={{ width: "339px" }}>
                  <Input
                    className="custom-input"
                    id="cols-select"
                    name="member"
                    type="select"                    
                    onChange={(event) =>
                      setFilters((prevFilters) => ({
                        ...prevFilters!,
                        selectedList: event.target.value,
                      }))
                    }
                    //  value={filters.selectedMember}
                  >
                    <option value="-1">Coluna</option>
                    {filters != null &&
                      filters.listData.length > 0 &&
                      filters.listData.map((e, i) => {
                        return (
                          <option key={i} value={e.id}>
                            {e.name}
                          </option>
                        );
                      })}
                  </Input>
                </Col>
              )}
              <Col md={2}>
                <Input
                  className="custom-input"
                  id="tool-select"
                  name="tool"
                  type="select"
                  onChange={(event) =>
                    setFilters((prevFilters) => ({
                      ...prevFilters!,
                      selectedTool: event.target.value,
                    }))
                  }
                >
                  <option value="-1">Selecione a Ferramenta</option>
                  {tools != null &&
                    tools.map((item, index) => {
                      return (
                        <option key={index} value={item.id}>
                          {item.name}
                        </option>
                      );
                    })}
                </Input>
              </Col>
            </div>
            {!filterBoxOpen ? (
              <BsArrowDownSquareFill
                className="arrow-down-and-up-icon"
                size={32}
                onClick={() => setFilterBoxOpen(!filterBoxOpen)}
              />
            ) : (
              <BsArrowUpSquareFill
              className="arrow-down-and-up-icon"
                size={32}
                onClick={() => setFilterBoxOpen(!filterBoxOpen)}
              />
            )}
          </div>
          {filterBoxOpen && (
            <Row className="mt-3">
              <Form>
                <Row>
                  <Col md={3}>
                    <Input
                    className="custom-input"
                      id="partner-email"
                      name="partner-email"
                      placeholder="E-mail do parceiro"
                      type="text"
                      onChange={(event) =>
                        setFilters((prevFilters) => ({
                          ...prevFilters!,
                          partnerEmail: event.target.value,
                        }))
                      }
                      value={filters?.partnerEmail}
                    />
                  </Col>
                  <Col md={3}>
                    <Input
                      id="customer-email"
                      className="custom-input"
                      name="customer-email"
                      placeholder="E-mail do cliente do parceiro"
                      type="text"
                      onChange={(event) => {
                        console.log(filters?.customerEmail);
                        setFilters((prevFilters) => ({
                          ...prevFilters!,
                          customerEmail: event.target.value,
                        }));
                        console.log(filters?.customerEmail);
                      }}
                      value={filters?.customerEmail}
                    />
                  </Col>
                  {type !== "mytasks" && (
                    <Col md={3}>
                      <Input
                        className="custom-input"
                        id="member-select"
                        name="member"
                        type="select"
                        onChange={(event) =>
                          setFilters((prevFilters) => ({
                            ...prevFilters!,
                            selectedMember: event.target.value,
                          }))
                        }
                        value={filters?.selectedMember}
                      >
                        <option value="-1">Responsável</option>
                        {filters?.memberData.map((element, index) => {
                          return (
                            <option key={index} value={element.trelloId || ""}>
                              {element.fullName}
                            </option>
                          );
                        })}
                      </Input>
                    </Col>
                  )}
                  <Col md={3}>
                    <Input
                    className="custom-input"
                      id="creation-filter"
                      name="creation-filter"
                      placeholder="Dias desde criada"
                      type="text"
                      onChange={(event) =>
                        setFilters((prevFilters) => ({
                          ...prevFilters!,
                          daysSinceCreation: event.target.value,
                        }))
                      }
                      value={filters?.daysSinceCreation}
                    />
                  </Col>
                  <Col md={3} className={type !== "mytasks" ? "mt-3" : ""}>
                    <Input
                    className="custom-input"
                      id="period-select"
                      name="select"
                      type="select"
                      onChange={(event) =>
                        setFilters((prevFilters) => ({
                          ...prevFilters!,
                          selectedPeriod: event.target.value,
                        }))
                      }
                      value={filters?.selectedPeriod}
                    >
                      <option value="-1">Período</option>
                      {periodOptions.map((element, index) => {
                        return (
                          <option key={index} value={element}>
                            {element}
                          </option>
                        );
                      })}
                    </Input>
                  </Col>
                  {filters?.selectedPeriod === "Personalizado" && (
                    <>
                      <Col md={3} className="mt-3">
                        <Input
                          id="init-date"
                          name="date"
                          placeholder="date placeholder"
                          type="date"
                          onChange={(event) =>
                            handleCustomDateChange(
                              "startDate",
                              event.target.value
                            )
                          }
                          value={filters.customPeriod.startDate}
                        />
                      </Col>
                      <Col md={3} className="mt-3">
                        <Input
                          id="end-date"
                          name="date"
                          placeholder="date placeholder"
                          type="date"
                          onChange={(event) =>
                            handleCustomDateChange(
                              "endDate",
                              event.target.value
                            )
                          }
                          value={filters.customPeriod.endDate}
                        />
                      </Col>
                      <Col md={3} className="mt-3">
                        <Button
                        id="button-filter"
                          color="info"
                          style={{ maxWidth: "100px" }}
                          onClick={() => {
                            setBoardTasks([]);
                            handleGetData();
                          }}                          
                        >
                          Filtrar
                        </Button>
                      </Col>
                    </>
                  )}
                  {
                    type === "all" && filters?.selectedMember !== "-1" && (
                      <Col md={3} className="mt-3">
                        <Input
                          id="status-select"
                          name="status"
                          type="select"
                          onChange={(event) =>
                            setFilters((prevFilters) => ({
                              ...prevFilters!,
                              selectedMemberStatus: event.target.value,
                            }))
                          }
                          value={filters?.selectedMemberStatus}
                        >
                          <option value="-1">Status</option>
                          <option value="assigned">Atribuídas</option>
                          <option value="completed">Concluídas</option>
                        </Input>
                      </Col>
                    )
                  }
                  {
                  filters &&
                  filters.selectedPeriod !== "Personalizado" && (
                    <Col md={3} className="mt-3">
                      <Button
                        color="secondary"
                        style={{ maxWidth: "100px"}}
                        onClick={() => {
                          setBoardTasks([]);
                          handleGetData();
                        }}
                        id="button-filter"
                      >
                        Filtrar
                      </Button>    
                    </Col>
                    
                  )}
                </Row>
              </Form>
            </Row>
          )}
        </Row>
      </div>
      <div className="mt-3 d-flex gap-3 align-items-center">
        <div className="d-flex align-items-center gap-1">
          <div
            className="ball-priority orange-ball-priority"
          ></div>
          <span className="priority-caption">Prioridade Média</span>
        </div>
        <div className="d-flex align-items-center gap-1">
          <div
            className="ball-priority red-ball-priority"
          ></div>
          <span className="priority-caption">Prioridade Alta / Altíssima</span>
        </div>
      </div>
      <div className="mt-3">
        {pageItens.length == 0 && isLoading? (
          <div className="d-flex flex-column justify-content-center align-items-center gap-5 mt-5">
            <BigText>Carregando...</BigText>
            <FillingBottle width="100px" height="100px" color="#dddcdc" />
          </div>
        ) : (
          <div>
            {pageItens.map((item:IFrontTask, index) => {
              return (
                <div
                  key={index}
                  className={`task-list-card ${getPriorityColor(
                    item.priority
                  )}`}
                  onDoubleClick={() => handleViewTask(item.trelloId)}
                >
                  <div 
                  className={`task-list-basic-data`}>
                    <div className="task-badges-row">
                      {(item.EhParceiroPrioritario ?? (item as any).ehParceiroPrioritario) && (
                        <div className="priority-badge">⭐ Prioridade</div>
                      )}
                      {item.toolsName != undefined &&
                        item.toolsName != null &&
                        item.toolsName.length > 0 && (
                          <>
                            {item.toolsName.map((tool: string, index) => {
                              return (                                
                                <Badge type="badge-tool-list" key={index}>
                                  {tool}
                                </Badge>
                              );
                            })}
                          </>
                        )}
                    </div>
                    <b>{item.title}</b>
                    <Box sx={{ flexGrow: 1 }}>
                      <Grid container spacing={1} style={{ gap: "1rem" }}>
                        {item.creatorName != null &&
                          item.creatorName !== "" &&
                          item.creatorName !== "Usuário" && (
                            <span
                              className="theme-text-color"
                              style={{ marginLeft: "8px" }}
                            >
                              <b>Criada Por:</b> {item.creatorName}
                            </span>
                          )}
                        {item.screenerName != null &&
                          item.screenerName !== "" && (
                            <span
                              className="theme-text-color"
                              style={{ marginLeft: "8px" }}
                            >
                              <b>Responsável Triagem:</b> {item.screenerName}
                            </span>
                          )}
                        {item.prManager != null &&
                          item.prManager !== undefined && (
                            <span
                              className="theme-text-color"
                              style={{ marginLeft: "8px" }}
                            >
                              <b>Responsável PR:</b> {item.prManager.name}
                            </span>
                          )}
                      </Grid>
                    </Box>
                    <Box sx={{ flexGrow: 1 }}>
                      <Grid container spacing={1} style={{ gap: "1rem" }}>
                        <span
                          className="theme-text-color"
                          style={{ marginLeft: "8px" }}
                        >
                          <b>Criado em:</b> {objectIdToDate(item.trelloId)}
                        </span>
                        <span
                          className="theme-text-color"
                          style={{ marginLeft: "8px" }}
                        >
                          <b>Criado há:</b> {countDays(item.trelloId)} dia(s)
                        </span>
                        <span
                          className="theme-text-color"
                          style={{ marginLeft: "8px" }}
                        >
                          <b>Status:</b> {item.listName}
                        </span>
                        <span
                          className="theme-text-color"
                          style={{ marginLeft: "8px" }}
                        >
                          <b>Prioridade:</b> {getItemPriority(item.priority)}
                        </span>
                        <span
                          className="theme-text-color"
                          style={{ marginLeft: "8px" }}
                        >
                          <b>Previsão Inicial:</b>{" "}
                          {item.finishDate != null
                            ? handleWithDate(item.finishDate)
                            : ""}
                        </span>
                      </Grid>
                    </Box>
                    <Box sx={{ flexGrow: 1 }}>
                      <Grid container spacing={1} style={{ gap: "1rem" }}>
                        <span
                          className="theme-text-color"
                          style={{ marginLeft: "8px" }}
                        >
                          <b>Versão:</b>{" "}
                          {/* {item.versions == null || item.versions ? "N/I" : item.version} */}
                          {item.versions !== null && item.versions.length > 0 ? item.versions[0]  : "N/I" }
                        </span>
                        <span
                          className="theme-text-color"
                          style={{ marginLeft: "8px" }}
                        >
                          <b>Parceiro:</b> {item.partnerEmail || ""}
                        </span>
                        <span
                          className="theme-text-color"
                          style={{ marginLeft: "8px" }}
                        >
                          <b>Cliente:</b> {item.customerEmail || ""}
                        </span>
                      </Grid>
                    </Box>
                    <Box sx={{ flexGrow: 1 }}>
                      <Grid container spacing={1} style={{ gap: "1rem" }}>
                        <span
                          className="theme-text-color"
                          style={{ marginLeft: "8px" }}
                        >
                          <b>Desenvolvedores:</b>{" "}
                          {item.devName != null && item.devName.length > 0
                            ? item.devName.join(", ")
                            : ""}
                        </span>              
                      </Grid>
                    </Box>
                  </div>
                  <div className="task-list-actions">
                    <div className="task-list-action-button">
                      <FaRegEye
                        className="pointer"
                        color="#0d6efd"
                        data-tooltip-id="view-dropdown"
                        data-tooltip-content="Visualizar"
                        data-tooltip-place="top"
                        onClick={() => handleViewTask(item.trelloId)}
                      />
                    </div>
                    {!pageScreening && (
                      <div className="task-list-action-button">
                        <UncontrolledDropdown>
                          <DropdownToggle data-toggle="dropdown" tag="span">
                            <FaExchangeAlt
                              className="pointer"
                              size={16}
                              color="#0d6efd"
                              data-tooltip-id="move-dropdown"
                              data-tooltip-content="Mover para"
                              data-tooltip-place="top"
                            />
                          </DropdownToggle>
                          <DropdownMenu container={"body"}>
                            <DropdownItem
                              onClick={() =>
                                setTaskToMoveId(item.trelloId)
                              }
                            >
                              Mover para o próximo status{" "}
                              {nextStateName ? `(${nextStateName})` : ""}
                            </DropdownItem>

                            <DropdownItem
                              onClick={() => {
                                setAvoidTaskId(item.trelloId);
                                handleAvoidTask();
                              }}
                            >
                              Mover para o status predecessor{" "}
                              {reproveStateName ? `(${reproveStateName})` : ""}
                            </DropdownItem>

                            {filters != null &&
                              filters.listData.length > 0 &&
                              canUserMoveTask() &&
                              filters.listData.map((e, i) => {
                                return (
                                  <DropdownItem
                                    key={i}
                                    onClick={() =>
                                      setStatusToMoveManually({name:e.name, id:item.trelloId})
                                    }
                                  >
                                    {e.name}
                                  </DropdownItem>
                                );
                              })}
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </div>
                    )}
                    {!pageScreening && (
                      <div className="task-list-action-button">
                        <FaPen
                          className="pointer"
                          color="#0d6efd"
                          data-tooltip-id="edit-dropdown"
                          data-tooltip-content="Editar"
                          data-tooltip-place="top"
                          onClick={() => handleEditItem(item.trelloId)}
                        />
                      </div>
                    )}
                    {!pageScreening && (
                      <div className="task-list-action-button">
                        <FaTrash
                          className="pointer"
                          color="#ff5e00"
                          onClick={() => {
                            setItemToDelete(item.trelloId);
                            setDeleteModal(!deleteModal);
                          }}
                          data-tooltip-id="delete-dropdown"
                          data-tooltip-content="Deletar"
                          data-tooltip-place="top"
                        />
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
            <div className="pagination-container">
              <Button
                color="info"
                onClick={() => handlePageChange(pagination.page - 1)}
                disabled={pagination.page === 0}
              >
                <FaArrowAltCircleLeft color="#fff" size={24} />
              </Button>
              <span className="pagination-index">
                {" "}
                Página {pagination.page + 1} de {pagination.totalPages}{" "}
              </span>
              <Button
                color="info"
                onClick={() => handlePageChange(pagination.page + 1)}
                disabled={pagination.page === pagination.totalPages - 1}
              >
                <FaArrowAltCircleRight color="#fff" size={24} />
              </Button>
            </div>
          </div>
        )}
      </div>
      <Modal 
        className={`${localStorage.getItem('mode') ? localStorage.getItem('mode') : 'light'}`} 
        isOpen={deleteModal} toggle={() => setDeleteModal(false)}>
        <ModalHeader
        className="modal-header-style theme-text-color"
        toggle={() => setDeleteModal(false)}>
          Deletar Tarefa
        </ModalHeader>
        <ModalBody 
        className="modal-body-style theme-text-color"
        >
          Esta ação não poderá ser desfeita! Tem certeza que deseja deletar a
          tarefa?
        </ModalBody>
        <ModalFooter
        className="modal-header-style theme-text-color"
        >
          <Button
            color="info"
            onClick={() => handleDeleteItem()}
            id="btn-delete-task"
          >
            Deletar
          </Button>{" "}
          <Button color="secondary" onClick={() => setDeleteModal(false)}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal 
        className={`${localStorage.getItem('mode') ? localStorage.getItem('mode') : 'light'}`} 
        isOpen={modalAvoidTask} toggle={() => setModalAvoidTask(false)}>
        <ModalHeader className="modal-header-style theme-text-color">
          Mover para o status predecessor{" "}
          {reproveStateName ? `(${reproveStateName})` : ""}
        </ModalHeader>
        <ModalBody className="modal-body-style theme-text-color">
          <Input
            className="input-modal theme-text-color"
            id="exampleText"
            name="text"
            type="textarea"
            rows="8"
            placeholder="Explique o motivo de estar movendo a tarefa e se a tarefa estiver incompleta, solicite mais informações sobre o problema."
            value={newComment}
            onChange={(e) => setNewComment(e.target.value)}
          />
        </ModalBody>
        <ModalFooter className="modal-footer-style">
          <Button
            color="info"
            onClick={() => handleNewAvoidTask()}
            id="btn-avoid-task"
          >
            Confirmar
          </Button>{" "}
          <Button color="secondary" onClick={() => setModalAvoidTask(false)}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>


      <MoveTaskModal
    isOpen={modalMoveTaskNextStatus}
    toggleModal={()=> setModalMoveTaskNextStatus(!modalMoveTaskNextStatus)}
    moveTask={() => handleMoveTaskNextStatus(taskToMoveId)}
    >
    </MoveTaskModal>

    <MoveTaskModal
    isOpen={modalMoveTask}
    toggleModal={()=> setModalMoveTask(!modalMoveTask)}
    moveTask={()=> handleMoveTask(statusToMoveManually.name, statusToMoveManually.id)}
    >
    </MoveTaskModal>



    </div>
  );
}

export default TasksList;
